/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {GlobalProps, setGlobalProps} from '@ion/dls/src/props/GlobalPropsConfig';

/**
 * Initializes the `GlobalPropConfig` with props of interest to the CalAmp
 * Application and it's application specific values.
 *
 * The `GlobalProps` are set during module initialization, thus, this module
 * need only be imported by a single module during pre-initialization, generally
 * the `src/store/actions/initialization.ts` module.
 *
 * ```typescript
 *   // /src/store/actions/initialization.ts
 *   ...
 *   import from '../../props';
 * ```
 *
 * @see {@link GlobalProps}
 * @see {@link setGlobalProps}
 */
setGlobalProps({
  'Application.Name'                                 : 'CalAmp Application (iOn)',
  'DevicesGrid.usePreferredDateTimeFormater'         : true,
  'date-time.formatter.useUserLocale'                : false,
  'DevicesGrid.anySearchForOnlyDisplayedColumns'     : true,
  'NotificationEditor.includeSnoozeStepper'          : true,
  'NotificationEditor.useLegacyTemplateUpdate'       : true,
  'NavigationItem.navBar.maxHeight'                  : 'calc(100vh - 176px)',
  'GlobalGroupChooser.desktop.useDrillDownHierarchy' : true,
  'grids.export.validation.enabled'                  : true,
  'global-groups.search.minMatchCharLength'          : 1,
  'grid.viewSubGroupsToggle.default.use.preference'  : false,
  'admin-groups.tripCategorization.enabled'          : true,
  'admin-groups.sftpConfigurations.v2.enabled'       : true
} as GlobalProps);
